import { Injectable, Scopes } from '@visiba/instantiation';
import { HttpResponse, HttpService } from '@application/http.service';
import { ApiBase } from './_api_base';
import type {
	AppointmentAccessApiModel,
	AppointmentCalendarInfoApiModel,
	PatientPolicyDocumentsApiModel,
	PublicBaseDataApiModel,
} from './generated/general/models';

@Injectable({
	scope: Scopes.Transient,
})
export class GeneralApiService extends ApiBase {
	constructor(private readonly httpService: HttpService) {
		super('general');
	}

	public get(alias: string): HttpResponse<number> {
		return this.httpService.get(`${this.baseUri}/licenceHolder/${alias}`);
	}

	public getAppointmentAccessInfo(callTicket: string): HttpResponse<AppointmentAccessApiModel> {
		return this.httpService.get(`${this.baseUri}/appointment/${callTicket}/accessInfo`);
	}

	public getCalendarInfo(callTicket: string): HttpResponse<AppointmentCalendarInfoApiModel> {
		return this.httpService.get(`${this.baseUri}/appointment/${callTicket}/calendarInfo`);
	}

	public getFeatureToggles(urlAlias: string): HttpResponse<Record<string, boolean>> {
		const url = this.httpService.createUrl(`${this.baseUri}/featureToggles`);
		url.searchParams.append('urlAlias', urlAlias);

		return this.httpService.get(url);
	}

	public setlanguage(languageCode: string): HttpResponse<unknown> {
		return this.httpService.put(`${this.baseUri}/language/setLanguage`, { LanguageCode: languageCode });
	}

	public getPatientBase(alias: string): HttpResponse<PublicBaseDataApiModel> {
		return this.httpService.get(`${this.baseUri}/licenceHolder/${alias}/publicBase`);
	}

	public getPolicyDocuments(alias: string, languageCode: string): HttpResponse<PatientPolicyDocumentsApiModel> {
		const url = this.httpService.createUrl(`${this.baseUri}/licenceHolder/${alias}/patient/policyDocuments`);
		url.searchParams.append('languageCode', languageCode);

		return this.httpService.get(url);
	}

	public getTranslationSets(
		licenceHolderId: number,
		translationsSets: string[],
		languageCode: string,
	): HttpResponse<Record<string, string>> {
		return this.httpService.get(`${this.baseUri}/translationSets/${licenceHolderId}/${translationsSets.join(',')}/${languageCode}`);
	}

	public touchSession(): HttpResponse<unknown> {
		return this.httpService.get(`${this.baseUri}/session/touch`);
	}
}
